module.exports = __webpack_public_path__ + "img/space-ship.d84b2498.svg";